import { EyeInvisibleOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  Button,
  Col,
  Pagination,
  Row,
  message
} from "antd";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { DeleteModal } from "components/Dialog";
import Loading from "components/Loading";
import { isEmpty, lowerCase } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import {
  useWorkSheetImageSelector,
  useWorkSheetSelector,
} from "store/worksheet/selectors";
import {
  handleCountPreview,
  handleDeleteWorksheetId,
  handleListWorkSheet,
  handleListWorkSheetUnverified,
  handleUpdateWorkSheetLog,
  handleUpdateWorksheetStatus,
  searchAdminWorksheet,
  totalQuestionBank,
} from "store/worksheet/thunks";
import styled from "styled-components";
import FilterCard from "./FilterCard";
import WorksheetTableRow from "./WorksheetTableRow";

//  -- Constants ----------------------

import COLOR from "utils/constants/color";

import { useCurrentUser } from "store/users/selectors";
import { setWorksheetView } from "store/worksheetView/action";
import { useWorksheetView } from "store/worksheetView/selector";
import { useHasPermission } from 'utils/permissions';
import {
  allCategories,
  allTenseData,
  getLabelsMoods,
  getMainForQuestionType,
  handleTypeText,
  moodsOption,
  pronounOptions,
  question_type_generate_more_worksheet
} from "../helper";
import PlayWorkSheet from "../Play";
import TeachersWorkSheet from "../TeachersWorkSheet";
import AdminTypes from "./types";
import CountPreview from "./countPreview";
import { ArrowBack } from "@mui/icons-material";
import BadgeButton from "components/AdminBooks/BadgeButton";

const StableWrapper = styled.div`
  width: 100%;

  overflow-x: auto;
`;

const StableWrapperMain = styled.div``;

const FilterContainer = styled.span`
  font-size: 17px;

  font-weight: 500;

  cursor: pointer;
`;

const MenuWrapper = styled.div`
  display: flex;

  flex-direction: row;

  //   justify-content: space-between;

  width: 100%;

  min-height: 80px;

  border-radius: 12px;

  //   border: 2px solid ${COLOR.black100};

  //   background-color: ${COLOR.blueish400};

  margin-top: ${(p) => (p.top ? p.top : "50px")};

  align-items: center;

  position: relative;

  padding: 2px 0px;

  flex-wrap: wrap;
`;

const MenuBtn = styled.button`
  background-color: white;

  border-top: none;

  border-left: none;

  border-right: none;

  cursor: pointer;

  font-size: 16px;

  font-weight: 600;

  outline: none;

  transition: all 300ms ease;

  padding: 2px 16px 10px 16px;

  min-width: 150px;

  margin-right: 2px;

  margin-left: 2px;

  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;

const MENU = [
  { id: "active_question", value: "Active Question" },
  { id: "unverified_question", value: "Unverified Question" },
  { id: "draft_question", value: "Draft Question" },
];

const WorksheetTableHeader = ({ dataTab }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Question No.
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Question
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Question Type
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Correct Answer
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Mood
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Tense
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Category
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Pronouns
        </TableCell>
        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Usage Count
        </TableCell>
        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Bug
        </TableCell>

        {dataTab == "draft_question" && (
          <TableCell
            style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
          >
            Media
          </TableCell>
        )}

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Edit
        </TableCell>

        <TableCell
          style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
        >
          Delete
        </TableCell>

        {dataTab != "draft_question" && (
          <TableCell
            style={{
              textAlign: "left",

              fontSize: 16,

              fontWeight: "600",
            }}
          >
            Preview
          </TableCell>
        )}

        {dataTab == "draft_question" && (
          <TableCell
            style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
          >
            Approve
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};

const WorkSheetTable = ({ userloading }) => {
  const showAlert = useAlert();
  const [allQuestionData, setAllQuestionData] = useState([]);
  const workSheetImage = useWorkSheetImageSelector();
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  
  const hasViewGrammarDrill = useHasPermission('grammar_drill.view');
  const hasAddGrammarDrill = useHasPermission('grammar_drill.add');
  const hasEditGrammarDrill = useHasPermission('grammar_drill.edit');
  const hasDeleteGrammarDrill = useHasPermission('grammar_drill.delete');
  const hasApproveGrammarDrill = useHasPermission('grammar_drill.approve');
  const hasGenerateDrill = useHasPermission('grammar_drill.generate_drill');
  
  const [dataTab, setDataTab] = useState(MENU[0].id);
  const [editStanderModal, setEditStanderModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteToggle, setDeleteToggle] = useState(false);
  const [approveToggle, setApproveToggle] = useState(false);
  const [loading, setLoader] = useState(false);
  const [isOpenAIModal, setIsOpenAIModal] = useState(false);
  const [openMannualQuestionModal, setOpenMannualQuestionModal] = useState(false);
  const [searchByName, setSearchName] = useState("");
  const [tense, setTense] = useState([]);
  const [pronouns, setPronouns] = useState([]);
  const [questionType, setQuestionType] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectedMoodOption, setSelectedMoodOption] = useState([]);
  const [approveLoading, setApproveLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const worksheetData = useWorkSheetSelector();
  const workSheetView = useWorksheetView();
  const [unverifiedCount, setUnverifiedCount] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [callForUpdateWorksheet, setCallForUpdateWorksheet] = useState(false);
  
  const [showCountPreview, setShowCountPreview] = useState(false);
  const [showCountPreviewLoader, setShowCountPreviewLoader] = useState(false);
  const [searchTotalCount, setSearchTotalCount] = useState(0);
  const [countData,setCountData] = useState({
    draft_question: 0,
    unverified_question: 0,
    active_question: 0
  });
  const [bugFilter,setBugFilter] = useState(false);
  const prevWorkSheetViewOpenRef = React.useRef(workSheetView?.open);

  const filtersRef = React.useRef({
    searchByName,
    selectedMoodOption,
    category,
    tense,
    pronouns,
    questionType,
  });

  const [pagination, setPagination] = useState({
    totalLength: 0,
    pageSize: 100,
    current: 1,
    pageSizeOptions: [],
    showSizeChanger: false,
  });

  useEffect(() => {
    if (Array.isArray(worksheetData)) {
      let questionArray = [];

      const sortedData = [...worksheetData].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });

      const filteredStatus = sortedData.filter((element) => {
        if (dataTab === "draft_question") {
          return element.status === false;
        } else if (dataTab === "unverified_question") {
          return element.status === true && !element.is_verified;
        } else {
          return element.status === true;
        }
      });
      
      filteredStatus.forEach((element) => {
        if (element?.question) {
          const questionData = {
            ...element?.question,
            id: element.id,
            image: element?.image,
            answer_audio: element?.answer_audio,
            question_audio: element?.question_audio,
            is_verified: element?.is_verified,
            status: element?.status,
            is_bug: element?.is_bug,
            usage_count: element?.usage_count,
          };
          questionArray.push(questionData);
        }
      });
      setAllQuestionData(questionArray);
    }
  }, [worksheetData, dataTab]);

  const fetchWorksheets = async (bugValue) => {
    setTableLoader(true);

    try {
      const draft_status = dataTab === "draft_question" ? false : true;
      const totalCount = await totalQuestionBank();
      const draftCount = totalCount?.draft_count || 0;
      const unverifiedCount = totalCount?.unverified_count || 0;
      const activeCount = totalCount?.active_count || 0;

      const bugCountDraft = totalCount?.draft_bug || 0;
      const bugCountUnverified = totalCount?.unverified_bug || 0;
      const bugCountActive = totalCount?.active_bug || 0;

      if(bugValue) {
        setCountData({
          draft_question: bugCountDraft,
          unverified_question: bugCountUnverified,
          active_question: bugCountActive
        });
      }else {
        setCountData({
          draft_question: draftCount,
          unverified_question: unverifiedCount,
          active_question: activeCount
        });
      }
      if (dataTab === "unverified_question") {
        if(bugValue) {
          setPagination((prev) => ({ ...prev, totalLength: bugCountActive }));
        }else {
          setPagination((prev) => ({ ...prev, totalLength: unverifiedCount }));
        }
      }else if (dataTab === "draft_question") {
        if(bugValue) {
          setPagination((prev) => ({ ...prev, totalLength: bugCountDraft }));
        }else {
          setPagination((prev) => ({ ...prev, totalLength: draftCount }));
        }
      }else {
        if(bugValue) {
          setPagination((prev) => ({ ...prev, totalLength: bugCountActive }));
        }else {
          setPagination((prev) => ({ ...prev, totalLength: activeCount }));
        }
      }
      
      
      const offset = (pagination.current - 1) * pagination.pageSize;
      let data = [];
      if (dataTab === "unverified_question") {
        data = await dispatch(handleListWorkSheetUnverified(
          "",
          currentUser?.role,
          currentUser?.id,
          pagination.pageSize,
          offset,
          draft_status,
          bugValue
        ));
      } else {
        data = await dispatch(handleListWorkSheet(
          "",
          currentUser?.role,
          currentUser?.id,
          pagination.pageSize,
          offset,
          draft_status,
          bugValue
        ));
      }

      if (Array.isArray(data)) {
        let questionArray = [];
        data.forEach((element) => {
          if (element?.question) {
            const questionData = {
              ...element?.question,
              id: element.id,
              image: element?.image,
              answer_audio: element?.answer_audio ? element.answer_audio : element?.question?.answer_audio,
              question_audio: element?.question_audio ? element?.question_audio : element?.question?.question_audio,
              is_verified: element?.is_verified,
              status: element?.status,
              is_bug: element?.is_bug,
              usage_count: element?.usage_count,
            };
            questionArray.push(questionData);
          }
        });
        setAllQuestionData(questionArray);
      } else {
        setAllQuestionData([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoader(false);
      if (workSheetView?.selectQnaOpen === false) {
        await dispatch(setWorksheetView({ selectQnaOpen: null }));
      }
    }
  };
  
  const hasAnyFilter = useMemo(() => {
    return searchByName?.length > 0 || 
           selectedMoodOption?.length > 0 || 
           category?.length > 0 || 
           tense?.length > 0 || 
           pronouns?.length > 0 || 
           questionType?.length > 0 
  }, [searchByName, selectedMoodOption, category, tense, pronouns, questionType]);

  useEffect(() => {
    const isPreviewOpenClose = prevWorkSheetViewOpenRef.current !== workSheetView?.open;
    prevWorkSheetViewOpenRef.current = workSheetView?.open;
    
    if (isPreviewOpenClose) {
      return;
    }
    
    if (!hasAnyFilter) {
      fetchWorksheets(bugFilter);
    }
  }, [pagination.current, pagination.pageSize, dataTab, workSheetView, hasAnyFilter]);
  
  const fetchUnverifiedCount = async () => {
    const totalCount = await totalQuestionBank();
    const unverifiedCount = totalCount?.unverified_count || 0;
    const activeCount = totalCount?.active_count || 0;
    setActiveCount(activeCount);
    setUnverifiedCount(unverifiedCount);
  };

  // useEffect(() => {
  //   fetchUnverifiedCount();
  // }, []);

  const handlePageChange = (page, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize: pageSize || prev.pageSize,
    }));
document.body.scrollTop=0;
  };

  useEffect(() => {
    setDataTab(MENU[0].id);
  }, []);

  const searchCall = async (bugValue) => {
    setTableLoader(true);
    try {
      filtersRef.current = {
        searchByName,
        selectedMoodOption,
        category,
        tense,
        pronouns,
        questionType,
      };
      const offset = (pagination.current - 1) * pagination.pageSize;
      const limit = pagination.pageSize;

      const currentFilters = filtersRef.current;

      let transformedData = {
        question: currentFilters.searchByName,
        mood: [],
        category: [],
        tense: [],
        pronouns: [],
        questionType: [],
        offset: offset,
        limit: limit,
        is_bug: bugValue || false,
      };

      if (currentFilters.selectedMoodOption?.length > 0) {
        transformedData.mood = getLabelsMoods(currentFilters.selectedMoodOption, moodsOption);
      }

      if (currentFilters.category?.length > 0) {
        const categoryData = allCategories();
        transformedData.category = categoryData
          ?.filter((opt) => currentFilters.category.includes(opt?.value))
          .map((opt) => opt.label);
      }

      if (currentFilters.tense?.length > 0) {
        const alltense = allTenseData();
        transformedData.tense = alltense
          ?.filter((opt) => currentFilters.tense.includes(opt?.value))
          .map((opt) => opt.label);
      }

      if (currentFilters.pronouns?.length > 0) {
        transformedData.pronouns = pronounOptions
          ?.filter((opt) => currentFilters.pronouns.includes(opt?.value))
          .map((opt) => opt.label);
      }

      if (currentFilters.questionType?.length > 0) {
        const questionTypeData = getMainForQuestionType(
          currentFilters.questionType,
          question_type_generate_more_worksheet
        );
        transformedData.questionType = questionTypeData.map((type) => handleTypeText(type) === 'Fill in the blanks' ? 'Fill_IN_THE_Blank' : handleTypeText(type) === 'Translate text' ? 'Translate_Text' : handleTypeText(type));
      }

      if (dataTab === "draft_question") {
        transformedData.draft = true;
      }

      const searchData = await searchAdminWorksheet(transformedData);
      if (searchData && searchData.data && Array.isArray(searchData.data)) {
        let questionArray = [];
        searchData.data.forEach((element) => {
          if (element?.question) {
            const questionData = {
              ...element?.question,
              id: element.id,
              image: element?.image,
              answer_audio: element?.answer_audio ? element.answer_audio : element?.question?.answer_audio,
              question_audio: element?.question_audio ? element?.question_audio : element?.question?.question_audio,
              is_verified: element?.is_verified,
              status: element?.status,
              is_bug: element?.is_bug,
              usage_count: element?.usage_count,
            };
            questionArray.push(questionData);
          }
        });
        setAllQuestionData(questionArray);
        
        const totalCount = searchData.total_count || 0;
        setSearchTotalCount(totalCount);
        setPagination((prev) => ({
          ...prev,
          totalLength: totalCount,
        }));
      } else {
        setAllQuestionData([]);
        setSearchTotalCount(0);
        setPagination((prev) => ({
          ...prev,
          totalLength: 0,
        }));
      }
    } catch (error) {
      console.log(error);
      setAllQuestionData([]);
    } finally {
      setTableLoader(false);
    }
  }

  const refreshWorksheets = useCallback(() => {
    if (hasAnyFilter) {
      searchCall(bugFilter);
      fetchUnverifiedCount();
    } else {
      fetchWorksheets(bugFilter);
    }
  }, [hasAnyFilter, searchCall, fetchWorksheets, bugFilter]);

  const filteredData = useMemo(() => {
    return allQuestionData.filter((element) => {
      if (dataTab === "draft_question") {
        return element.status === false;
      } else if (dataTab === "unverified_question") {
        return element.status === true && !element.is_verified;
      } else {
        return element.status === true;
      }
    });
  }, [allQuestionData, dataTab]);

  const paginatedData = useMemo(() => {
    return filteredData;
  }, [filteredData]);

  useEffect(() => {
    if (hasAnyFilter) {
      setPagination((prev) => ({
        ...prev,
        current: 1,
      }));
      setSearchTotalCount(0);
    }
  }, [
    searchByName,
    selectedMoodOption,
    category,
    tense,
    pronouns,
    questionType,
  ]);

  useEffect(() => {
    filtersRef.current = {
      searchByName,
      selectedMoodOption,
      category,
      tense,
      pronouns,
      questionType,
    };
  }, [searchByName, selectedMoodOption, category, tense, pronouns, questionType]);

  useEffect(() => {
    if (hasAnyFilter) {
      const timeoutId = setTimeout(() => {
        searchCall(bugFilter);
      }, 500);
      
      return () => clearTimeout(timeoutId);
    }
  }, [hasAnyFilter, pagination.current, pagination.pageSize, dataTab, searchByName, selectedMoodOption, category, tense, pronouns, questionType]);

  const onDeleteItem = async (edit) => {
    if (!selectedItem) return;

    const data = {
      question_id: selectedItem?.id,
      user_id: currentUser?.id,
      question_title: selectedItem?.question,
      message_type: "delete",
    };

    const fitlerData = worksheetData?.filter((x) => x.id !== selectedItem?.id);
    setLoader(true);
    await dispatch(handleDeleteWorksheetId(selectedItem?.id));
    showAlert("Question Deleted successfully!", "success");
    handleUpdateWorkSheetLog(data);
    setLoader(false);
    setDeleteToggle(false);
    refreshWorksheets();

    if (fitlerData?.length === 0 && editMode) {
      setOpenMannualQuestionModal(false);
      return;
    }
    if (editMode) {
      handleEditForward(selectedItem, "delete");
      return;
    }
    resetPagination();
    setOpenMannualQuestionModal(false);
  };

  const onApproveItem = () => {
    setDeleteToggle(false);
    handleDraftQuestion(selectedItem);
  };

  const handleEditItem = (item) => {
    setEditMode(true);
    setSelectedItem(item);
    setEditStanderModal(true);
    setOpenMannualQuestionModal(true);
    setCallForUpdateWorksheet(false);
  };

  const onClose = async () => {
    if (editStanderModal) {
      setEditStanderModal(false);
      setSelectedItem(null);
    }
    if(callForUpdateWorksheet) {
      refreshWorksheets();
      setCallForUpdateWorksheet(false);
    }
    setOpenMannualQuestionModal(false);
    setEditMode(false);
    // await dispatch(
    //   handleListWorkSheet(
    //     "",
    //     currentUser?.role,
    //     currentUser?.id,
    //     100,
    //     0,
    //     dataTab === MENU[0]?.id ? true : false
    //   )
    // );
  };

 

  function navigationToMenu(id) {
    setDataTab(id);
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  }

  const handleDraftQuestion = async (item) => {
    const data = {
      id: item?.id,
      status: true,
    };

    const dataLog = {
      question_id: item?.id,
      user_id: currentUser?.id,
      question_title: item?.question,
      message_type: "marked as active",
    };
    setApproveLoading(data?.id);
    const result = await dispatch(handleUpdateWorksheetStatus(data));
    handleUpdateWorkSheetLog(dataLog);

    if (!result?.id) {
      showAlert("Something went wrong, please try again!", "error");
    } else {
      showAlert("Question approved successfully!", "success");
      refreshWorksheets();
    }

    setApproveLoading(false);
    setApproveToggle(false);
  };

  const handleEditBackWard = async (item) => {
    const selectedItemData = item ? item : selectedItem;
    const findByIndex = allQuestionData?.findIndex(
      (x) => x.id === selectedItemData?.id
    );
    if (findByIndex === 0){
      setSelectedItem(allQuestionData[allQuestionData?.length - 1]);
      return;
    };
    const data = allQuestionData[findByIndex - 1];
    setSelectedItem(data);
  };

  const handleEditForward = async (item, actionType = "") => {
    const selectedItemData = item || selectedItem;
    const findByIndex = allQuestionData?.findIndex(
      (x) => x.id === selectedItemData?.id
    );
  
    if (findByIndex === -1 || allQuestionData?.length === 0) return;
  
    // if it's the last item, cycle to the first one
    if (findByIndex === allQuestionData.length - 1) {
      setSelectedItem(allQuestionData[0]);
      return;
    }
  
    // otherwise go to next item
    const nextItem = allQuestionData[findByIndex + 1];
    setSelectedItem(nextItem);
  };
  

  const handleDeleteEdit = (item) => {
    setDeleteToggle(true);
  };

  const resetPagination = async () => {
    if (allQuestionData?.length === 1) {
      await dispatch(
        handleListWorkSheet(
          "",
          currentUser?.role,
          currentUser?.id,
          100,
          0,
          true
        )
      );
    }
  };

  const handleShowCountPreview = async () => {
    setShowCountPreviewLoader(true);
    await dispatch(handleCountPreview())
    setShowCountPreview(true)
    setShowCountPreviewLoader(false);
  }

  return (
    <>
      <StableWrapperMain>
        <Row style={{ marginBottom: 15 }}>
          <Col className="gap-10px flex items-center adminWorksheetBtn">
            {!showCountPreview && hasViewGrammarDrill && (
              <>
                <Button style={{ minHeight: 38 }} onClick={() => {
                  if (!hasAddGrammarDrill) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                  }
                  setOpenMannualQuestionModal(true);
                }}>
                  <PlusOutlined /> Add Question
                </Button>

                <Button style={{ minHeight: 38 }} onClick={() => {
                  if (!hasGenerateDrill) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                  }
                  setIsOpenAIModal(true);
                }}>
                  <PlusOutlined /> Add Question From AI
                </Button>
              </>
            )}
          </Col>
          {/* {!showCountPreview ? (
          <div style={{ marginLeft: 'auto' }} className="adminWorksheetBtn">
            <Button
              style={{ minHeight: 38, marginLeft: 'auto' }}
              onClick={() => {
                handleShowCountPreview()
              }}
            >
              {showCountPreviewLoader ? <Loading size={18} white /> : <EyeInvisibleOutlined />} Show Count Preview
            </Button>
          </div>
          ) : (
            <div style={{ marginLeft: 'auto', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }} className="adminWorksheetBtn" onClick={() => setShowCountPreview(false)}>
              <ArrowBack style={{ fontSize: 16, marginRight: 4 }} />
              <span>Back to Worksheet</span>
            </div>
          )} */}

          {!showCountPreview ? (
            <div style={{ marginLeft: 'auto' }} className="adminWorksheetBtn">
              <BadgeButton
                onClick={() => handleShowCountPreview()}
                startIcon={showCountPreviewLoader ? <Loading size={18} white /> : <EyeInvisibleOutlined />}
                showBadge={false}
                size="medium"
                className="countPreviewBtn"
                style={{
                  backgroundColor: 'unset',
                  backgroundImage: 'linear-gradient(90deg, #2563eb 0%, #06b6d4 100%)',
                  borderRadius: 10,
                  height: 42,
                  minWidth: 160
                }}
              >
                Show Count Preview
              </BadgeButton>
            </div>
          ) : (
            <div style={{ marginLeft: 'auto', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }} className="adminWorksheetBtn" onClick={() => setShowCountPreview(false)}>
              <ArrowBack style={{ fontSize: 16, marginRight: 4 }} />
              <span>Back to Worksheet</span>
            </div>
          )}
        </Row>

        <TeachersWorkSheet isOpen={isOpenAIModal} setIsOpen={setIsOpenAIModal} />

        {showCountPreview && <CountPreview  />}

        <AdminTypes
          isOpen={openMannualQuestionModal}
          isEdit={editStanderModal}
          selectedItem={selectedItem}
          handleEditBackWard={handleEditBackWard}
          handleEditForward={handleEditForward}
          onClose={onClose}
          handleDeleteQuestionBank={(edit) => handleDeleteEdit(edit, 'delete')}
          dataTab={dataTab}
          fetchWorksheets={refreshWorksheets}
          onUpdateWorksheet={() => setCallForUpdateWorksheet(true)}
        />
        {!showCountPreview && hasViewGrammarDrill && (
          <FilterContainer className="FilterHeading">
            <FilterCard
              search_by_name={searchByName}
              setSearchByName={setSearchName}
              search_by_questionType={questionType}
              setSearchByQuestionType={setQuestionType}
              search_by_category={category}
              setSearchByCategory={setCategory}
              searchByPronouns={pronouns}
              setSearchByPronouns={setPronouns}
              search_by_tense={tense}
              setSearchByTense={setTense}
              selectedmoodOption={selectedMoodOption}
              setMoodOption={setSelectedMoodOption}
              loading={tableLoader}
              bugFilter={bugFilter}
              setBugFilter={(value) =>{
                if(hasAnyFilter) {
                  setPagination((prev) => ({ ...prev, current: 1 }));
                  searchCall(value);
                }else{
                  setPagination((prev) => ({ ...prev, current: 1 }));
                  fetchWorksheets(value);
                }
                setBugFilter(value);
              }}
            />
          </FilterContainer>
        )}

        {!showCountPreview && hasViewGrammarDrill && (
        <MenuWrapper top={'10px'} style={{ width: '100%' }}>
          {MENU?.map((x) => (
            <MenuBtn
              style={{
                borderBottom: dataTab === x?.id ? '5px solid rgb(28,49,115)' : '5px solid #fcfcfc',

                color: dataTab === x?.id ? 'rgb(28,49,115)' : 'black',
              }}
              key={x.id}
              onClick={() => navigationToMenu(x.id)}
              disabled={tableLoader}
            >
              {x.value} ({countData[x.id]})
            </MenuBtn>
          ))}
        </MenuWrapper>
        )}

        <PlayWorkSheet handleNextWorksheet={() => {}} isPreview={true} />

        {!showCountPreview && (
          <>
            {(dataTab == MENU[0].id || dataTab == "unverified_question") && (
              <StableWrapper>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    marginTop: 20,
                  }}
                >
                  <WorksheetTableHeader 
                    dataTab={dataTab} 
                  />
                  {tableLoader ? (
                    <>
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={(() => {
                            return 13;
                          })()} align="center">
                            <div style={{ padding: '20px 0' }}>
                              <Loading size={30} />
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </>
                  ) : (
                    <TableBody>
                      {isEmpty(filteredData) &&
                        (userloading ? (
                          <Loading size={30} />
                        ) : (
                          <TableRow key={'0'} style={{ border: 0 }}>
                            <TableCell colSpan={(() => {
                              const baseCols = 11;
                              const editCol = hasEditGrammarDrill ? 1 : 0;
                              const deleteCol = hasDeleteGrammarDrill ? 1 : 0;
                              return baseCols + editCol + deleteCol;
                            })()} style={{ textAlign: 'center' }}>
                              No results
                            </TableCell>
                          </TableRow>
                        ))}
                      {!isEmpty(filteredData) && (
                        <>
                          {paginatedData.map((row, index) => {
                          const globalIndex = (pagination.current - 1) * pagination.pageSize + index;
                          return(
                            <WorksheetTableRow
                              key={row.id}
                              row={row}
                              index={globalIndex}
                              pagination={pagination}
                              dataTab={dataTab}
                              handleEditItem={handleEditItem}
                              setDeleteToggle={setDeleteToggle}
                              setSelectedItem={setSelectedItem}
                              handleDraftQuestion={handleDraftQuestion}
                              approveLoading={approveLoading}
                              userloading={userloading}
                              hasEditGrammarDrill={hasEditGrammarDrill}
                              hasDeleteGrammarDrill={hasDeleteGrammarDrill}
                              hasApproveGrammarDrill={hasApproveGrammarDrill}
                              onPreviewClick={async () => {
                                await dispatch(
                                  setWorksheetView({
                                    activeIndex: globalIndex,
                                    questions: filteredData,
                                    open: true,
                                  }),
                                );
                              }}
                            />
                          )
                          })}
                        </>
                      )}

                      {!isEmpty(filteredData) && (
                        <TableRow>
                          <TableCell colSpan={(() => {
                            return 13;
                          })()} align="right">
                            <Pagination
                              current={pagination.current}
                              pageSize={pagination.pageSize}
                              total={pagination.totalLength || 0}
                              onChange={handlePageChange}
                              showSizeChanger={false}
                              pageSizeOptions={pagination.pageSizeOptions}
                              onShowSizeChange={(current, size) => {
                                setPagination((prev) => ({
                                  ...prev,
                                  current: 1,
                                  pageSize: size,
                                }));
                              }}
                              itemRender={(page, type, originalElement) => {
                                if (type === 'page' && page === pagination.current) {
                                  return (
                                    <div className="ant-pagination-item-active custom-active-page">
                                      {page}
                                    </div>
                                  );
                                }

                                return originalElement;
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  )}
                </Table>
              </StableWrapper>
            )}

            {dataTab == "draft_question" && (
              <StableWrapper>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    marginTop: 20,
                  }}
                >
                  <WorksheetTableHeader 
                    dataTab={dataTab} 
                  />
                  {tableLoader ? (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={(() => {
                          return 14;
                        })()} align="center">
                          <div style={{ padding: '20px 0' }}>
                            <Loading size={30} />
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <TableBody>
                      {isEmpty(filteredData) &&
                        (userloading ? (
                          <Loading size={30} />
                        ) : (
                          <TableRow key={'0'} style={{ border: 0 }}>
                            <TableCell colSpan={(() => {
                              const baseCols = 11;
                              const editCol = hasEditGrammarDrill ? 1 : 0;
                              const deleteCol = hasDeleteGrammarDrill ? 1 : 0;
                              const approveCol = hasApproveGrammarDrill ? 1 : 0;
                              return baseCols + editCol + deleteCol + approveCol;
                            })()} style={{ textAlign: 'center' }}>
                              No results
                            </TableCell>
                          </TableRow>
                        ))}

                      {!isEmpty(filteredData) &&
                        paginatedData.map((row, index) => {
                          const globalIndex = (pagination.current - 1) * pagination.pageSize + index;
                          return (
                            <WorksheetTableRow
                              key={row.id}
                              row={row}
                              index={globalIndex}
                              pagination={pagination}
                              dataTab={dataTab}
                              handleEditItem={handleEditItem}
                              setDeleteToggle={setDeleteToggle}
                              setSelectedItem={setSelectedItem}
                              setApproveToggle={setApproveToggle}
                              handleDraftQuestion={handleDraftQuestion}
                              approveLoading={approveLoading}
                              userloading={userloading}
                              hasEditGrammarDrill={hasEditGrammarDrill}
                              hasDeleteGrammarDrill={hasDeleteGrammarDrill}
                              hasApproveGrammarDrill={hasApproveGrammarDrill}
                            />
                          );
                        })}

                      {!isEmpty(filteredData) && (
                        <TableRow>
                          <TableCell colSpan={(() => {
                            const baseCols = 11;
                            const editCol = hasEditGrammarDrill ? 1 : 0;
                            const deleteCol = hasDeleteGrammarDrill ? 1 : 0;
                            const approveCol = hasApproveGrammarDrill ? 1 : 0;
                            return baseCols + editCol + deleteCol + approveCol;
                          })()} align="right">
                            <Pagination
                              current={pagination.current}
                              pageSize={pagination.pageSize}
                              total={pagination.totalLength || 0}
                              onChange={handlePageChange}
                              showSizeChanger={pagination.showSizeChanger}
                              pageSizeOptions={pagination.pageSizeOptions}
                              itemRender={(page, type, originalElement) => {
                                if (type === 'page' && page === pagination.current) {
                                  return (
                                    <div className="ant-pagination-item-active custom-active-page">
                                      {page}
                                    </div>
                                  );
                                }
                                return originalElement;
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  )}
                </Table>
              </StableWrapper>
            )}
          </>
        )}
      </StableWrapperMain>

      <DeleteModal
        deleteToggle={deleteToggle}
        setDeleteToggle={setDeleteToggle}
        onDelete={onDeleteItem}
        message={`Are you sure you want to delete this question?`}
        loading={loading}
      />
      <DeleteModal
        deleteToggle={approveToggle}
        setDeleteToggle={setApproveToggle}
        onDelete={onApproveItem}
        message={`This question has no media. Are you sure you want to approve it?`}
        loading={loading}
        buttonTitle="Approve"
      />
    </>
  );
};

export default WorkSheetTable;
